import { Box, styled } from '@mui/system'
import { alpha, IconButton } from '@mui/material'

interface SidebarChatMessagesOpenButtonProps {
	readonly open?: boolean
}

const SidebarChatMessagesBodyLoader = styled(Box)`
	display: flex;
	align-items: center;
	justify-content: center;
	padding-bottom: 16rem;
	padding-top: 16rem;
`

const SidebarChatMessagesOpenButton = styled(IconButton, {
	shouldForwardProp: prop => prop !== 'open',
})<SidebarChatMessagesOpenButtonProps>(({ theme, open }) => ({
	fontSize: '2rem',
	minWidth: '3rem',
	width: '3rem',
	maxWidth: '3rem',
	marginTop: '2.25rem',
	marginLeft: '0.4rem',
	backgroundColor: open ? alpha(theme.palette.common.white, 0.1) : 'unset',
	borderRadius: '0.625rem',
}))

export { SidebarChatMessagesBodyLoader, SidebarChatMessagesOpenButton }
